// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div class="box">
  <sub-header header="\$ctrl.title"></sub-header>

    <form name="\$ctrl.form">
      <form-section>

        <table class="table">
          <tbody>
          <tr>
            <td>Account type:</td>
            <td class="values">
              <input type="text"
                     disabled
                     max="64"
                     ng-model="\$ctrl.accountType.productDefinition.productName"
              />
            </td>
          </tr>
          <tr>
            <td>Group name:</td>
            <td class="values">
              <input type="text"
                     max="64"
                     ng-model="\$ctrl.accountGroup.name"
                     required/>
            </td>
          </tr>
          </tbody>
        </table>

      </form-section>

      <div class="flex-end">
        <button class="btn btn-warning"
                type="button"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>

        <button class="btn btn-primary" ng-click="\$ctrl.saveGroup()"
                type="button"
                ng-disabled="\$ctrl.form.\$invalid">
          Save
        </button>
      </div>
    </form>

</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/account-group/details/account-group-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;